import React from 'react'
import MainForgot from '../../components/auth/forgotpassword/main'
import Footer from '../../components/footer'

function ForgotPassword() {
    return (
        <>
            <MainForgot />
            <Footer />
        </>
    )
}

export default ForgotPassword